/**
 * User & People Icons
 * 
 * Icons for user profiles, contacts, teams, and people-related features.
 * 
 * Used by: User profiles, contacts, team management, authentication
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser as fadUser,
  faUserCircle as fadUserCircle,
  faUsers as fadUsers,
  faUserPen as fadUserPen,
  faUserPlus as fadUserPlus,
  faUserFriends as fadUserFriends,
  faUserShield as fadUserShield,
  faUserHeadset as fadUserHeadset,
  faUserMagnifyingGlass as fadUserMagnifyingGlass,
  faUsersGear as fadUsersGear,
  faUsersSlash as fadUsersSlash,
  faPerson as fadPerson,
  faChildReaching as fadChildReaching,
  faPeopleGroup as fadPeopleGroup,
  faPeopleRoof as fadPeopleRoof,
  faScreenUsers as fadScreenUsers,
  faFamily as fadFamily,
  faIdCard as fadIdCard,
  faIdBadge as fadIdBadge,
  faAddressBook as fadAddressBook,
  faAddressCard as fadAddressCard,
  faFaceSmile as fadFaceSmile,
  faFaceGrimace as fadFaceGrimace,
  faFaceGlasses as fadFaceGlasses,
  faUserHeadset as fadUserHeadset2,
  faUserMinus as fadUserMinus,
  faBuildingUser as fadBuildingUser,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faUsers as fasUsers,
} from "@fortawesome/pro-solid-svg-icons";

import {
  faUser as fatUser,
  faFamily as fatFamily,
} from "@fortawesome/pro-thin-svg-icons";

export const loadUserIcons = () => {
  // Duotone user icons
  library.add(
    fadUser,
    fadUserCircle,
    fadUsers,
    fadUserPen,
    fadUserPlus,
    fadUserFriends,
    fadUserShield,
    fadUserHeadset,
    fadUserMagnifyingGlass,
    fadUsersGear,
    fadUsersSlash,
    fadPerson,
    fadChildReaching,
    fadPeopleGroup,
    fadPeopleRoof,
    fadScreenUsers,
    fadFamily,
    fadIdCard,
    fadIdBadge,
    fadAddressBook,
    fadAddressCard,
    fadFaceSmile,
    fadFaceGrimace,
    fadFaceGlasses,
    fadUserHeadset2,
    fadUserMinus,
    fadBuildingUser,
  );

  // Solid user icons
  library.add(fasUsers);

  // Thin user icons
  library.add(
    fatUser,
    fatFamily,
  );
};
